import { Injectable } from '@angular/core';
import { User } from '../models/usuario.model';
@Injectable()
export class RoutingParams {
  public primeraUrl: string;
  public turnoConfirmar: any;
  public turnoDetalle: any;


  constructor() {}
}
